import { nextTick, watch, type Ref } from 'vue'

/**
 * 管理每个操作的引用，支持“新增后自动聚焦编辑输入”。
 */
export function useCardRefs<T extends { __id?: string }>(displayData: Ref<T[]>) {
  // 仅用于命令式聚焦，不需要做成响应式，避免批量挂载时每次 ref 回调都触发渲染
  const cardRefMap: Record<string, any> = {}

  const registerCardRef = (id: string | undefined, el: any) => {
    if (!id) return

    if (el) {
      cardRefMap[id] = el
      return
    }

    delete cardRefMap[id]
  }

  watch(
    () => displayData.value.map((item) => item.__id).join(','),
    () => {
      const visibleIds = new Set(displayData.value.map((item) => item.__id).filter(Boolean))
      for (const id of Object.keys(cardRefMap)) {
        if (!visibleIds.has(id)) {
          delete cardRefMap[id]
        }
      }
    },
  )

  const openDelayEditor = async (id?: string) => {
    if (!id) return
    await nextTick()
    cardRefMap[id]?.startEditDelay?.()
  }

  const openCoordinateXEditor = async (id?: string) => {
    if (!id) return
    await nextTick()
    cardRefMap[id]?.startEditX?.()
  }

  const findNextRecordId = (id?: string) => {
    if (!id) return undefined
    const index = displayData.value.findIndex((item) => item.__id === id)
    if (index < 0) return undefined
    return displayData.value[index + 1]?.__id
  }

  return {
    registerCardRef,
    openDelayEditor,
    openCoordinateXEditor,
    findNextRecordId,
  }
}
